import { FilterSearchingBaseViewModel, PagingResultsViewModel } from 'src/app/components/core/_infrastructure/types/common';

export class TransicionEstadoUdInspeccionCamViewModel {
    public Id: number;
    public IdResultadoInspeccionCam: number;
    public IdEstadoUnidadInspeccionCam: number;
    public IdTipoInspeccionCam: number;
    public IdPerfilUsuario: number;
    public IdSiguienteEstadoUnidadInspeccionCam: number;
}

export class TransicionEstadoUdInspeccionCamItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: TransicionEstadoUdInspeccionCamItemViewModel[];
}

export class TransicionEstadoUdInspeccionCamItemViewModel {
    public Id: number;
    public IdResultadoInspeccionCam: number;
    public IdResultadoInspeccionCamDescripcion: string;
    public IdEstadoUnidadInspeccionCam: number;
    public IdEstadoUnidadInspeccionCamDescripcion: string;
    public IdTipoInspeccionCam: number;
    public IdTipoInspeccionCamDescripcion: string;
    public IdPerfilUsuario: number;
    public IdPerfilUsuarioDescripcion: string;
    public IdSiguienteEstadoUnidadInspeccionCam: number;
    public IdSiguienteEstadoUnidadInspeccionCamDescripcion: string;
}

export class FilterSearchingTransicionEstadoUdInspeccionCamViewModel extends FilterSearchingBaseViewModel {
    public IdResultadoInspeccionCam: number;
    public IdEstadoUnidadInspeccionCam: number | null;
    public IdTipoInspeccionCam: number;
    public IdPerfilUsuario: number;
    public IdSiguienteEstadoUnidadInspeccionCam: number | null;
}
